// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueGlobalVar from 'vue-global-var'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import '@/assets/global.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faCheckCircle,
  faTimesCircle,
  faCheck,
  faTimes,
  faArrowCircleRight,
  faArrowCircleLeft,
  faArrowCircleDown,
  faFilePdf,
  faEdit
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import axios from 'axios'
import VueAxios from 'vue-axios'

library.add(faCheck)
library.add(faTimes)
library.add(faCheckCircle)
library.add(faTimesCircle)
library.add(faArrowCircleRight)
library.add(faArrowCircleLeft)
library.add(faArrowCircleDown)
library.add(faFilePdf)
library.add(faEdit)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(BootstrapVue)
Vue.use(ElementUI)
Vue.config.productionTip = false

Vue.use(VueAxios, axios)
Vue.axios.defaults.baseURL = 'https://epuu.fi/wp-json/wp/v2/'

Vue.use(VueGlobalVar, {
  globals: {
    userSelection: {
      kayttotarkoitus: null,
      autosuojaosana: 'Ei',
      myymalaosana: 'Ei',
      irtainvarastoja: 'Ei',
      kt: 1,
      ktid: 1,
      kerrosmaara: null,
      sprinklaus: 'Ei',
      korkeus: null,
      kerrosala: null,
      henkilomaara: null,
      tilat: null,
      yopymistilat: null,
      results: {
        p1: null,
        p2: null,
        p3: null,
        p0: {passed: true, kerrosmäärä: true, korkeus: true, kerrosala: true, henkilomäärä: true, paloosasto: true, runko: 'Tapauskoht.', mitoitus: 'Toiminnallinen', error: ''}
      },
      single: {
        suunnittelija: '',
        tyonro: '',
        tekija: '',
        pvm: '',
        tunnus: '',
        rakennuskohde: '',
        sisalto: ''
      },
      rakenne: '',
      sisainenmelu: '',
      sisainenmelu1: '',
      ulkoinenmelu: '',
      currentSelection: []
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js